const SPACING: Record<"input" | "label", string> = {
  input: "12px",
  label: "22px",
};

const SUBSECTION_CARD_PADDING = "1rem";
const SMALL_INPUT_WIDTH = "80px";

export { SMALL_INPUT_WIDTH, SPACING, SUBSECTION_CARD_PADDING };
